import { render, staticRenderFns } from "./UserSupport.vue?vue&type=template&id=9f05ec62&scoped=true&"
import script from "./UserSupport.vue?vue&type=script&lang=ts&"
export * from "./UserSupport.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f05ec62",
  null
  
)

export default component.exports